import { useCallback, useMemo } from 'react';

import { useTranslationInfo } from '@/hooks/useTranslationInfo';
import { STT_STATUS } from '@/states/slices/translationInfoSlice';

/**
 * フッターに関するhooks
 * @returns
 */
export const useTranslationFooter = () => {
  const { sttStatus } = useTranslationInfo();

  /**
   * プログレスの表示
   * true = 表示する
   */
  const isVisibledSpinner = useMemo(() => {
    if (sttStatus === STT_STATUS.READY) {
      return true;
    }

    if (sttStatus === STT_STATUS.CONNECTING) {
      return false;
    }

    return false;
  }, [sttStatus]);

  /**
   * フッターのSTTボタン画像の出し分け判定
   */
  const fetchSttButtonImg = useCallback(() => {
    if (sttStatus === STT_STATUS.CONNECTING) {
      return `talk-on`;
    }

    return `talk-off`;
  }, [sttStatus]);

  return {
    isVisibledSpinner,
    fetchSttButtonImg,
  };
};
